import React from "react";
import Head from "next/head";
import Feature from "../../components/Feature";
import Pic from "../../components/Pic";

const Page = () => (
    <>
        <Head>
            <title>5 Tips on How to Keep Your Guests Engaged at Your Hybrid Wedding</title>
            <meta name="description" content="Here are 5 tips for keeping your virtual and physical guests engaged at your hybrid wedding" />
            <link href="https://fonts.googleapis.com/css2?family=Cormorant&display=swap" rel="stylesheet" />
            <link rel="canonical" href="https://tacboard.com/stories/hybrid-wedding-5-tips" />
            <meta property="og:title" content="5 Tips for a Hybrid Wedding" />
            <meta property="og:description" content="Planning a hybrid event with some guests present virtually" />
            <meta property="og:image" content="https://imagedelivery.net/uvaLOqv6E4g37MA5AJ8WJg/77a77205-23de-41cd-6606-6f8a95cbca00/public" />
        </Head>

        <Feature>
            <h1>5 Tips on How to Keep Your Guests Engaged at Your Hybrid Wedding</h1>

            <time dateTime="2022-01-18">January 18, 2022</time>

            <p>A new trend is calling. Hybrid events. Now, distance is no longer an issue to have your beloved guests at your wedding, or a corporate event.</p>

            <figure>
                <Pic
                    alt="bride and groom torso"
                    src="https://imagedelivery.net/uvaLOqv6E4g37MA5AJ8WJg/77a77205-23de-41cd-6606-6f8a95cbca00"
                    originalWidth={1366}
                    originalHeight={768}
                    width={1366}
                    height={768}
                    widths={[600, 800, 1200]}
                    sizes="(max-width: 800px) 96vw, 800px"
                />
            </figure>

            <p>But with this trend comes new problems. How do you keep a guest engaged? Keep them interested? Let us show you 5 tips on how to do just that, so you can get on with what is important. Your event!</p>

            <h2>Tip 1 - Adjust Your Stream For All Bandwidths</h2>

            <p>Not everybody is going to have a gigabit connection. There will be relatives, or people with budget constraints, that may have less than satisfactory internet connection speeds.</p>

            <p>Rather than stream your event in 4K, try to do either of these 2 things. Use a streaming software that automatically adjusts the quality to the watchers' bandwidth, or stream natively in a low resolution, like 720p.</p>

            <h2>Tip 2 - Have A Music Playlist</h2>

            <p>The benefits of streaming your event come with unique strengths. You can stream audio and video together, but you can also add more audio to the mix.</p>

            <p>If you have someone who is controlling the stream, you can create a cue list. They’ll play the specified music in time with the right event. It can make those moments just a bit more heartfelt, making them stay as delightful memories.</p>

            <p>You can also save the recording of the stream, so you have a well produced “home video” of the event that you can be proud of.</p>

            <h2>Tip 3 - Have An Online Guest Media Library</h2>

            <p>One may think that hybrid events focus on interactivity for the online user, but it also includes enhancing the experience for your in-person guests.</p>

            <p>By using ready for purpose software, or even keeping it simple and sharing a Google Drive, online viewers can post pictures of themselves, or anything relevant to the wedding, as they watch your event.</p>

            <p>Everyone present at your event can look through this gallery and collect their own memories from people who aren’t there.</p>

            <h2>Tip 4 - Social Media Integration</h2>

            <p>Getting people included is as easy as it’s ever been. By utilizing social media, you can have a live, intractable way for your online guests to partake in your wedding, or event.</p>

            <p>Having a live Twitter feed is one way to keep both types of guests engaged, especially with a viewable monitor at the venue. A live chat can also be incorporated for the same effect.</p>

            <h2>Tip 5 - Set Up A Monitor</h2>

            <p>We’ve mentioned this multiple times in the previous tips, but no hybrid event is complete without a monitor or two, on view, for every person to interact and engage with.</p>

            <p>It’s not just limited to livestreams. You can use one to show the online guest gallery and cycle through the pictures. You can even use them to showcase information, like schedules or food menus.</p>

            <h2>Hybrid Weddings Are A Brilliant Thing</h2>

            <p>Hosting a hybrid wedding allows everyone to take part, regardless of distance, so nobody will miss your treasured moments.</p>

            <p>With these tips, you’ll be able to set up a beautiful hybrid wedding, and absolutely everyone will get to take part in making memories of your special event.</p>



        </Feature>
    </>
);

export default Page;
